module.exports = __webpack_public_path__ + "1f8f76cc474e5212bd7ccf3162a0476c.png";